import type { ColumnDef } from '@tanstack/react-table';

import { type GetProductPriceRangesQuery } from 'data/__generated__';
import { textColumn } from 'components/DataTable';

export type ProductPriceRangeRow = GetProductPriceRangesQuery['productPriceRanges'][number];

type ProductPriceRangeFilterInput = {
    searchValue: string;
};

export const productPriceRangesColumns: ColumnDef<ProductPriceRangeRow, unknown>[] = [
    textColumn<ProductPriceRangeRow, ProductPriceRangeFilterInput>({
        accessorKey: 'name',
        header: 'Nom',
        defaultVisible: true,
    }),
];
